import { Device } from '../types';
import { useDeviceStore } from './store';

export const actionsCreator = ({
  setState
}: {
  // TODO: add correct type for setState
  setState: (data: Device) => void;
}) => {
  return {
    SET_DEVICE: (data: Device) => {
      setState(data);
    }
  };
};

export const deviceActions = actionsCreator(useDeviceStore);
